import React from 'react';
import Typography from '@mui/material/Typography';
var RenderStringOrComponent = function (_a) {
    var toRender = _a.toRender, _b = _a.variant, variant = _b === void 0 ? 'hint' : _b, className = _a.className;
    if (typeof toRender === 'string') {
        return (React.createElement(Typography, { variant: variant, className: className }, toRender));
    }
    if (typeof toRender === 'function') {
        return toRender();
    }
    return null;
};
export default RenderStringOrComponent;
